export default __webpack_public_path__ + "static/media/activeHamburger.68aa6368.svg";